/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomerRegisteryEnabledDto
 */
export interface CustomerRegisteryEnabledDto {
    /**
     * 
     * @type {boolean}
     * @memberof CustomerRegisteryEnabledDto
     */
    enabled: boolean;
}

/**
 * Check if a given object implements the CustomerRegisteryEnabledDto interface.
 */
export function instanceOfCustomerRegisteryEnabledDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "enabled" in value;

    return isInstance;
}

export function CustomerRegisteryEnabledDtoFromJSON(json: any): CustomerRegisteryEnabledDto {
    return CustomerRegisteryEnabledDtoFromJSONTyped(json, false);
}

export function CustomerRegisteryEnabledDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerRegisteryEnabledDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
    };
}

export function CustomerRegisteryEnabledDtoToJSON(value?: CustomerRegisteryEnabledDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
    };
}

